
// Old Platform User
export class MotimaticUser {
  label: string;
  value: string;
  email: string;
  userType: string;
  constructor() {
      this.label = "";
      this.value = "";
      this.email = "";
      this.userType = "";
  }
}
